import type {
  CustomerAccount,
  CustomerDevicesResponse,
  CustomerInfoResponse,
  CustomerLicensesResponse,
  CustomerLoginPayload,
  CustomerLoginResponse
} from '../types.js';
import { ApiError, getJson, postJson } from '../http.js';

export const customerApi = {
  async login(payload: CustomerLoginPayload): Promise<CustomerAccount> {
    const response = await postJson<CustomerLoginResponse>('/auth/customer/login', payload, { ignoreUnauthorized: true });
    if (!response?.success) {
      throw new ApiError(401, 'invalid_credentials', response);
    }
    return response.customer;
  },

  logout(): Promise<{ success: boolean }> {
    return postJson('/auth/customer/logout');
  },

  getSession(): Promise<CustomerAccount> {
    return getJson('/auth/customer/session');
  },

  getCurrentCustomer(): Promise<CustomerInfoResponse> {
    return getJson('/customer/me');
  },

  getCustomerInfo(customerId: string): Promise<CustomerInfoResponse> {
    return getJson(`/customer/info/${customerId}`);
  },

  getCustomerDevices(customerId: string): Promise<CustomerDevicesResponse> {
    return getJson(`/customer/${customerId}/devices`);
  },

  getCustomerLicenses(customerId: string): Promise<CustomerLicensesResponse> {
    return getJson(`/customer/${customerId}/licenses`);
  }
};


